import { BaseModel } from "@blue-chip/core";

export default class WorkScope extends BaseModel {}
